export default __webpack_public_path__ + "static/media/edu-bg.ad2d5e3a.jpg";